//destination

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { RouterModule, Routes } from '@angular/router';
//import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
//import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
//import { AlertModule,AlertConfig } from 'ngx-bootstrap/alert';
import { AccordionModule } from 'ngx-bootstrap/accordion';
//import { BsDropdownModule,BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { TabsModule, TabsetConfig } from 'ngx-bootstrap/tabs';
import { NgSelectModule } from '@ng-select/ng-select';
//import {NgFileDragDropModule} from  'ng-file-drag-drop';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { TimeFormatPipe } from './models/time-format.pipe';
import { TimeAgoPipe } from './models/time-ago.pipe';
import { TruncateTextNewPipe } from './models/truncatetext.pipe';
import { StripHtmlPipe } from './models/strip-html.pipe';
import { UserIdleModule } from 'angular-user-idle';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import {QuillModule} from 'ngx-quill'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgRecaptcha3Service } from "ng-recaptcha3";


import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ModalFocusComponent } from './modal-focus/modal-focus.component';
import { MeetingMinutesComponent } from './meeting-minutes/meeting-minutes.component';
import { MeetingActionComponent } from './meeting-action/meeting-action.component';
import { DigitalAttendanceComponent } from './digital-attendance/digital-attendance.component';
import { LogintypeComponent } from './logintype/logintype.component';
import { LoginpingComponent } from './loginping/loginping.component';
import { ViewMeetingComponent } from './view-meeting/view-meeting.component';
import { AddMeetingComponent } from './add-meeting/add-meeting.component';
import { MeetingTypeComponent } from './settings/meeting-type/meeting-type.component';
import { MeetingLocationComponent } from './settings/meeting-location/meeting-location.component';
import { MeetingRoomComponent } from './settings/meeting-room/meeting-room.component';
import { UserMasterComponent } from './settings/user-master/user-master.component';
import { SearchComponent } from './search/search.component';
import { ReportComponent } from './report/report.component';
import { UserprofileComponent } from './userprofile/userprofile.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { MeetingActionListComponent } from './meeting-action-list/meeting-action-list.component';
import { NotificationListComponent } from './notification-list/notification-list.component';
import { AddAttendenceComponent } from './add-attendence/add-attendence.component';
import { ViewAttendenceComponent } from './view-attendence/view-attendence.component';
import { MustMatchDirective } from './services/must-match.directive';
import { DelegateMeetingMinutesComponent } from './delegate-meeting-minutes/delegate-meeting-minutes.component';
import { VideoguideComponent } from './videoguide/videoguide.component';
import { ResetMeetingActionComponent } from './reset-meeting-action/reset-meeting-action.component';

import { Requestor,FetchRequestor } from '@openid/appauth';
import { AuthorizationService } from './services/authorization.service';
import { AuthorizationConfig } from './services/authorization_config';
import { CallbackComponent } from './callback/callback.component';
import { environment } from '../environments/environment';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { ExternalloginComponent } from './externallogin/externallogin.component';
import { AuthGuard } from './auth.guard';
import { LoginRedirectGuard } from './login-redirect.guard';

export const appRoutes: Routes = [
  // Logintype only for manual login (Ping disabled)
  { path: '', component: LogintypeComponent, canActivate: [LoginRedirectGuard], pathMatch: 'full' },
  { path: 'logintype', component: LogintypeComponent, canActivate: [LoginRedirectGuard] },

  // Public login routes (Ping or manual)
  { path: 'loginping', component: LoginpingComponent },
  { path: 'extlogin', component: ExternalloginComponent },
  { path: 'callback', component: CallbackComponent },
  { path: 'accessdenied', component: AccessDeniedComponent },

  // Protected routes (require AuthGuard)
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'meetingofminutes', component: MeetingMinutesComponent, canActivate: [AuthGuard] },
  { path: 'meetingaction', component: MeetingActionComponent, canActivate: [AuthGuard] },
  { path: 'digitalattendance', component: DigitalAttendanceComponent, canActivate: [AuthGuard] },
  { path: 'testmodal', component: ModalFocusComponent, canActivate: [AuthGuard] },
  { path: 'meetingtype', component: MeetingTypeComponent, canActivate: [AuthGuard] },
  { path: 'meetinglocation', component: MeetingLocationComponent, canActivate: [AuthGuard] },
  { path: 'meetingroom', component: MeetingRoomComponent, canActivate: [AuthGuard] },
  { path: 'usermaster', component: UserMasterComponent, canActivate: [AuthGuard] },
  { path: 'search', component: SearchComponent, canActivate: [AuthGuard] },
  { path: 'report', component: ReportComponent, canActivate: [AuthGuard] },
  { path: 'userprofile', component: UserprofileComponent, canActivate: [AuthGuard] },
  { path: 'meetingactionlist', component: MeetingActionListComponent, canActivate: [AuthGuard] },
  { path: 'notificationlist', component: NotificationListComponent, canActivate: [AuthGuard] },
  { path: 'delegatemeetingminutes', component: DelegateMeetingMinutesComponent, canActivate: [AuthGuard] },
  { path: 'videoguide', component: VideoguideComponent, canActivate: [AuthGuard] },
  { path: 'resetmeetingaction', component: ResetMeetingActionComponent, canActivate: [AuthGuard] },

  // Catch-all redirect (fallback)
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,    
    SidebarComponent,
    TimeFormatPipe,
    TimeAgoPipe,
    TruncateTextNewPipe,
    StripHtmlPipe,
    DashboardComponent,
    AccessDeniedComponent,
    MeetingActionComponent,
    DigitalAttendanceComponent,
    ModalFocusComponent,
    MeetingMinutesComponent,
    LogintypeComponent,
    LoginpingComponent,
    ViewMeetingComponent,
    AddMeetingComponent,
    MeetingTypeComponent,
    MeetingLocationComponent,
    MeetingRoomComponent,
    UserMasterComponent,
    SearchComponent,
    ReportComponent,
    UserprofileComponent,
    MeetingActionListComponent,
    NotificationListComponent,
    AddAttendenceComponent,
    ViewAttendenceComponent,
    MustMatchDirective,
    DelegateMeetingMinutesComponent,
    VideoguideComponent,
    ResetMeetingActionComponent,
    CallbackComponent,
    ExternalloginComponent
  ],
  imports: [
    BrowserModule,
    //NgFileDragDropModule,
    DragDropModule,
    ReactiveFormsModule,
    NgbModule,  
    FormsModule,
    NgSelectModule,
    BrowserAnimationsModule,
    ButtonsModule,
    //BsDropdownModule,
    AccordionModule,
    //BsDatepickerModule,
   // AlertModule,
    ImageCropperModule,
    CollapseModule,
   // CarouselModule,
    TabsModule,
    ModalModule.forRoot(),
    QuillModule.forRoot({
      modules: {
        syntax: false,
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],        
         // [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
          [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          //[{ 'font': [] }],
          [{ 'align': [] }],
          ['clean']                                        // remove formatting button
         // ['link', 'image', 'video']                         // link and image, video
        ]
      }
    }),
    UserIdleModule.forRoot({ idle: 1175, timeout: 25, ping: 100 }),
    HttpClientModule,
    ToastrModule.forRoot(), 
    RouterModule.forRoot(appRoutes, { useHash: true }),
    FileUploadModule,
  ],
  providers: [
    BsModalService, 
    TabsetConfig, 
    NgRecaptcha3Service,
    AuthorizationService, { provide: Requestor, useValue: new FetchRequestor() },
    ,{ provide: 'AuthorizationConfig', useValue: environment }
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }



